import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=6eff6a3c&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=6eff6a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff6a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eff6a3c')) {
      api.createRecord('6eff6a3c', component.options)
    } else {
      api.reload('6eff6a3c', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=6eff6a3c&scoped=true&", function () {
      api.rerender('6eff6a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Dialog/Error.vue"
export default component.exports